import { GripVertical, X } from 'lucide-react';
import { ReactNode } from 'react';

interface WidgetWrapperProps {
  children: ReactNode;
  isEditMode?: boolean;
  title?: string;
  onRemove?: () => void;
  className?: string;
}

export function WidgetWrapper({
  children,
  isEditMode = false,
  title: _title,
  onRemove,
  className = ''
}: WidgetWrapperProps) {
  return (
    <div className={`relative ${isEditMode ? 'cursor-move' : ''} ${className}`}>
      {isEditMode && (
        <>
          {/* Drag Handle - Top Left */}
          <div className="absolute top-2 left-2 z-10 bg-white rounded-md shadow-md p-1 border border-[#e7e7e7]">
            <GripVertical className="w-4 h-4 text-[#808080]" />
          </div>

          {/* Remove Button - Top Right */}
          {onRemove && (
            <button
              onClick={onRemove}
              className="absolute top-2 right-2 z-10 bg-white rounded-md shadow-md p-1 border border-[#e7e7e7] hover:bg-[#e30840] hover:border-[#e30840] group transition-colors"
            >
              <X className="w-4 h-4 text-[#808080] group-hover:text-white transition-colors" />
            </button>
          )}

          {/* Edit Mode Border Overlay */}
          <div className="absolute inset-0 border-2 border-[#e30840] rounded-md pointer-events-none opacity-50"></div>
        </>
      )}
      {children}
    </div>
  );
}
